module.exports = __webpack_public_path__ + "static/media/exclaimWhite.16c5eed2.svg";